import { styled } from '@mui/material/styles';
import React, { CSSProperties } from 'react';
import SwipeableViews from 'react-swipeable-views';
import classNames from 'classnames';
import Indicator from './Indicator';

const PREFIX = 'BaseImageSlider';

const classes = {
  slider: `${PREFIX}-slider`,
  swipeableView: `${PREFIX}-swipeableView`,
  indicator: `${PREFIX}-indicator`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.slider}`]: {
    position: 'relative',
    height: '100%',
  },

  [`& .${classes.swipeableView}`]: {
    height: '100%',
  },

  [`& .${classes.indicator}`]: {
    /*display:none*/
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    paddingBottom: '5px !important',
  },
}));

interface IProps {
  onSlideChanged: (slide: number) => void;
  currentSlide: number;
  sliderClass?: string;
  children: React.ReactNode;
}

const BaseImageSlider = (props: IProps) => {
  const heightStyle: CSSProperties = {
    height: '100%',
  };

  const onChangeIndex = (index: number, previous: number) => {
    props.onSlideChanged(index);
  };

  return (
    <Root className={classNames(classes.slider, props.sliderClass)}>
      <SwipeableViews
        index={props.currentSlide}
        onChangeIndex={onChangeIndex}
        className={classes.swipeableView}
        containerStyle={heightStyle}
        slideStyle={heightStyle}
        enableMouseEvents
      >
        {props.children}
      </SwipeableViews>
      <Indicator
        className={classes.indicator}
        total={React.Children.count(props.children)}
        current={props.currentSlide}
        onDotClicked={props.onSlideChanged}
      />
    </Root>
  );
};

export default BaseImageSlider;
